import gql from 'graphql-tag'
import { Fragment } from './fragment'

export const query = gql`
  ${Fragment}
  query fetchNegotiation($id: Int!) {
    records: purchase_negotiation_by_pk(id: $id) {
      ...NegotiationForm
    }
  }
`

export default query
